<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Arrows / left arrow">
      <path
        id="Vector"
        d="M9.33339 14.6663H19.4534L15.0534 10.2796C14.8023 10.0285 14.6613 9.688 14.6613 9.33293C14.6613 8.97786 14.8023 8.63733 15.0534 8.38626C15.3045 8.13519 15.645 7.99414 16.0001 7.99414C16.3551 7.99414 16.6957 8.13519 16.9467 8.38626L23.6134 15.0529C23.7348 15.1797 23.8299 15.3293 23.8934 15.4929C24.0267 15.8175 24.0267 16.1816 23.8934 16.5063C23.8299 16.6699 23.7348 16.8195 23.6134 16.9463L16.9467 23.6129C16.8228 23.7379 16.6753 23.8371 16.5128 23.9048C16.3503 23.9725 16.1761 24.0073 16.0001 24.0073C15.824 24.0073 15.6498 23.9725 15.4873 23.9048C15.3248 23.8371 15.1773 23.7379 15.0534 23.6129C14.9284 23.489 14.8292 23.3415 14.7615 23.179C14.6938 23.0166 14.659 22.8423 14.659 22.6663C14.659 22.4902 14.6938 22.316 14.7615 22.1535C14.8292 21.991 14.9284 21.8435 15.0534 21.7196L19.4534 17.3329H9.33339C8.97977 17.3329 8.64063 17.1925 8.39058 16.9424C8.14053 16.6924 8.00006 16.3532 8.00006 15.9996C8.00006 15.646 8.14053 15.3068 8.39058 15.0568C8.64063 14.8067 8.97977 14.6663 9.33339 14.6663Z"
        fill="#110F13"
      />
    </g>
  </svg>
</template>
